import { getApiUrl } from '../config/env';
import { Notification, NotificationCount } from '../types/notification';

/**
 * Fetches all notifications for the current user
 */
export async function fetchNotifications(): Promise<Notification[]> {
  try {
    const response = await fetch(getApiUrl('/api/notifications'), {
      credentials: 'include'
    });

    if (!response.ok) {
      throw new Error(`Failed to fetch notifications: ${response.status}`);
    }

    return await response.json();
  } catch (error) {
    console.error('Error fetching notifications:', error);
    return [];
  }
}

/**
 * Fetches the count of unread notifications
 */
export async function fetchUnreadCount(): Promise<number> {
  try {
    const response = await fetch(getApiUrl('/api/notifications/unread-count'), {
      credentials: 'include'
    });

    if (!response.ok) {
      throw new Error(`Failed to fetch unread count: ${response.status}`);
    }

    const data: NotificationCount = await response.json();
    return data.unread_count;
  } catch (error) {
    console.error('Error fetching unread count:', error);
    return 0;
  }
}

/**
 * Marks a notification as read
 */
export async function markAsRead(notificationId: string): Promise<boolean> {
  try {
    const response = await fetch(getApiUrl(`/api/notifications/${notificationId}/read`), {
      method: 'PUT',
      credentials: 'include'
    });

    if (!response.ok) {
      throw new Error(`Failed to mark notification as read: ${response.status}`);
    }

    return true;
  } catch (error) {
    console.error('Error marking notification as read:', error);
    return false;
  }
} 